/* eslint-disable prefer-arrow-callback */

/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * Vue 2 Autocomplete @ Version 0.0.1
 *
 */

var debounce = function (callback, delay, ...args) {
  let timeout;
  return function () {
    const context = this;
//      const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      callback.apply(context, args);
    }, delay);
  };
}
export default {
  props: {
    id: String,
    className: String,
    placeholder: String,
    // Intial Value
    initValue: {
      type: String,
      default: '',
    },
    // Anchor of list
    anchor: {
      type: String,
      required: true,
    },
    // Label of list
    label: String,
    // Debounce time
    debounce: Number,
    // ajax URL will be fetched
    url: {
      type: String,
//        required: true,
    },
    // query param
    param: {
      type: String,
      default: 'q',
    },
    // Custom Params
    customParams: Object,
    // minimum length
    min: {
      type: Number,
      default: 0,
    },
    suggest: Array,
    // Process the result before retrieveng the result array.
    process: Function,
    // Callback
    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    additionalData: Object,
  },
  data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
    };
  },
  methods: {
    // Netralize Autocomplete
    clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    // Get the original data
    cleanUp(data) {
      return JSON.parse(JSON.stringify(data));
    },
    input(val) {
      this.showList = val.length > 1;
      // Callback Event
      if (this.onInput) {
        this.onInput(val);
      }
      // Debounce the "getData" method.
      if (!this.debouncedGetData || this.debounce !== this.oldDebounce) {
        this.oldDebounce = this.debounce;
        this.debouncedGetData = this.debounce ? debounce(this.getData.bind(this),
          this.debounce) : this.getData;
      }
      // Get The Data
      this.debouncedGetData(val);
    },
    showAll() {
      this.json = this.suggest;
//        this.json = [];
//        this.getData('');
      // Callback Event
      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    hideAll(e) {
      // Callback Event
      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(() => {
        // Callback Event
        if (this.onHide) {
          this.onHide();
        }
        this.showList = false;
      }, 250);
    },
    focus(e) {
      this.focusList = 0;
      // Callback Event
      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove(i) {
      this.focusList = i;
    },
    keydown(e) {
      const key = e.keyCode;
      // Disable when list isn't showing up
      if (!this.showList) return;
      switch (key) {
        case 40: // down
          this.focusList += 1;
          break;
        case 38: // up
          this.focusList -= 1;
          break;
        case 13: // enter
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          this.clearInput();
          break;
        case 27: // esc
          this.showList = false;
          this.clearInput();
          break;
        default:
          break;
      }
      // When cursor out of range
      const listLength = this.json.length - 1;
      const tmp = (this.focusList < 0) ? listLength : this.focusList;
      this.focusList = this.focusList > listLength ? 0 : tmp;
    },
    activeClass(i) {
      return {
        'focus-list': i === this.focusList,
      };
    },
    selectList(data) {
      const clean = this.cleanUp(data);
      // Put the selected data to type (model)
      this.type = clean[this.anchor];
      this.showList = false;

      /**
       * Callback Event
       * Deep clone of the original object
       */
      if (this.onSelect) {
        this.onSelect(clean, data, this.additionalData);
      }
      this.clearInput();
    },
    getData(val) {
      var self = this;
      this.json = this.suggest.filter(function (item) {
        return item[self.anchor].toLowerCase().indexOf(val.toLowerCase())+1;
        // return true;
      });
    },
//      getData(val) {
//        const self = this;
//        if (val.length < this.min) return;
//        if (this.url != null) {
//          // Callback Event
//          if (this.onBeforeAjax) {
//            this.onBeforeAjax(val);
//          }
//          const ajax = new XMLHttpRequest();
//          let params = '';
//          if (this.customParams) {
//            Object.keys(this.customParams).forEach((key) => {
//              params += `&${key}=${this.customParams[key]}`;
//            });
//          }
//          ajax.open('GET', `${this.url}?${this.param}=${val}${params}`, true);
//          ajax.send();
//          ajax.addEventListener('progress', function (data) {
//            if (data.lengthComputable) {
//              // Callback Event
//              if (this.onAjaxProgress) {
//                this.onAjaxProgress(data);
//              }
//            }
//          });
//          ajax.addEventListener('loadend', function () {
//            const json = JSON.parse(this.responseText);
//            // Callback Event
//            if (this.onAjaxLoaded) {
//              this.onAjaxLoaded(json);
//            }
//            self.json = self.process ? self.process(json) : json;
//          });
//        }
//      },
    setValue(val) {
      this.type = val;
    },
  },
  created() {
    // Sync parent model with initValue Props
    this.type = this.initValue ? this.initValue : null;
  },
};



// WEBPACK FOOTER //
// ./src/components/autocomplete/vue-autocomplete.js